import angular from 'angular';
import _ from 'lodash';

class CommunitySvc {
    /* @ngInject */
    constructor(CommunityDA, LegalNoticeDA, WorkflowDA, CONF, $filter, COMMUNITY) {
        this.CommunityDA = CommunityDA;
        this.LegalNoticeDA = LegalNoticeDA;
        this.WorkflowDA = WorkflowDA;
        this.CONF = CONF;
        this.$filter = $filter;
        this.COMMUNITY = COMMUNITY;

        this._menu = null;
        this._communityEid = null;
        this._community = null;
    }

    /**
     * Sauvegarde d'une communauté.
     */
    saveCommunity(community) {
        return this.CommunityDA.saveCommunity(community);
    }

    /**
     * Modification d'une communauté.
     */
    updateCommunity(community) {
        return this.CommunityDA.updateCommunity(community);
    }

    importMembers(criteria) {
        return this.CommunityDA.importMembers(criteria);
    }

    uploadCgaZip(document, eid) {
        return this.CommunityDA.uploadCgaZip(document, eid);
    }

    getCgaInfos(eid) {
        return this.CommunityDA.getCgaInfos(eid);
    }

    getCgaZip(documentId) {
        return this.CommunityDA.getCgaZip(documentId);
    }

    getReportWithLink(report) {
        report.name = 'RPT-' + 'REFSOCCOM' + '-' + this.$filter('date')(new Date(), 'dd-MM-yyyy_HH-mm-ss') + '.csv';
        report.link = this.CONF.apiContext + this.CONF.apiBaseUrl + '/v1/files/' + report.reportId;
        return report;
    }

    /**
     * Récupération d'une Communauté
     *
     * @param {Number} page - page of list
     * @param {Number} size - size of list
     */
    getAllCommunities(page, size) {
        return this.CommunityDA.getAllCommunities(page, size);
    }

    /**
     * Récupération d'une Communauté
     *
     * @param {Number} id - identifiant d'une communauté
     *
     */
    getCommunityById(id) {
        return this.CommunityDA.getCommunityById(id).then(data => {
            return data;
        });
    }

    getAllCompaniesOfCommunity(communityEid, pageNumber, size) {
        return this.CommunityDA.getAllCompaniesOfCommunity(communityEid, pageNumber, size);
    }

    /**
     * Initialisation du menu
     */
    initMenuCommunity(eid) {
        this._menu = null;
        this.refreshCommunity(eid).then(data => {
            this._community = data;
            if (eid) {
                this._menu = _.map(angular.copy(this.COMMUNITY.menuCommunity), menuItem => {
                    menuItem.link += `({'eid': '${eid}'})`;
                    return menuItem;
                }).filter(
                    menuItem =>
                        !(menuItem.id === 'stock-software' && this._community.managingStockSoftware === false) &&
                        !(menuItem.id === 'groupement-community' && this._community.managingStockSoftware === false) &&
                        !(menuItem.id === 'managing-referential' && this._community.managingReferential === false) &&
                        !(menuItem.id === 'managing-orders' && this._community.managingOrders === false) &&
                        !(menuItem.id === 'desadv-param' && this._community.managingDesAdv === false) &&
                        !(menuItem.id === 'managing-orders-response' && this._community.managingOrderResponse === false)
                );
                this.setMenuItemsCommunity(this._menu);
            }
        });
    }

    /**
     * Récupération des item du menu vertical à gauche
     */
    getMenuItemsCommunity() {
        return this._menu;
    }

    setMenuItemsCommunity(menu) {
        this._menu = menu;
    }

    /**
     * Setter EID Communauté
     */
    setCommunityEid(eid) {
        this._communityEid = eid;
    }

    /**
     * Getter EID Communauté
     */
    getCommunityEid() {
        return this._communityEid;
    }

    /**
     * Récupération de la communauté courante
     */
    getCommunityByEid() {
        return this._community;
    }

    /**
     * Récupération de la communauté sur le serveur
     *
     * @param {Number} eid - identifiant métier communauté
     *
     */
    refreshCommunity(eid) {
        return this.CommunityDA.getCommunityById(eid).then(data => {
            this._community = data;
            return this._community;
        });
    }

    /**
     * Supprime d'une community.
     * @param eid Identifiant d'une community
     */
    deleteComunity(eid) {
        return this.CommunityDA.deleteComunity(eid);
    }

    /**
     * Recherche tous les logiciels de stock agrée DiagDirect
     */
    getAllStockSoftware() {
        return this.CommunityDA.getAllStockSoftware();
    }

    /**
     * Modifie la configuration du portail de la communauté.
     */
    updateCommunityPortal(community) {
        return this.CommunityDA.updateCommunityPortal(community);
    }

    /**
     * Récupère un logiciel de stock agrée DiagDirect par nom de logiciel.
     */
    getStockSoftware(id) {
        return this.CommunityDA.getStockSoftware(id);
    }

    /**
     * Modifie un logiciel de stock agrée DiagDirect.
     */
    updateStockSoftware(stockSoftware) {
        return this.CommunityDA.updateStockSoftware(stockSoftware);
    }

    /**
     * Crée un logiciel de stock agrée DiagDirect.
     */
    createStockSoftware(stockSoftware) {
        return this.CommunityDA.createStockSoftware(stockSoftware);
    }

    /**
     * Vérifie que le nom d'un logiciel de stock agréé DiagDirect n'est pas utilisé.
     */
    checkStockSoftwareName(name) {
        return this.CommunityDA.checkStockSoftwareName(name);
    }

    /**
     * Récupère de la personnalisation pour la communauté.
     */
    getBrand(communityId) {
        return this.CommunityDA.getBrand(communityId);
    }

    /**
     * Récupère la liste des références workflow associées à une communauté pour les demandes d'achat.
     * @param eid Identifiant d'une community
     */
    getWkfOrderEntryReferences(eid) {
        return this.WorkflowDA.getOrderEntryReferences(eid);
    }

    /**
     * Récupère la liste des référentiels data repo d'une communauté
     * @param querySearchCriteria contient idenfiant d'une communauté
     */
    getAllReferentialsOfCommunity(querySearchCriteria) {
        return this.CommunityDA.getAllReferentialsOfCommunity(querySearchCriteria);
    }

    /**
     * Enregistrer la liste des référentiels data repo d'une communauté
     * @param querySearchCriteria contient idenfiant d'une communauté
     * @param referentials liste des référentiels
     */
    saveAllReferentials(querySearchCriteria, referentials) {
        return this.CommunityDA.saveAllReferentials(querySearchCriteria, referentials);
    }

    /**
     * Récupère les mentions légales d'une communauté
     * @param communityEid idenfiant d'une communauté
     */
    getLegalNotices(communityEid) {
        return this.LegalNoticeDA.getLegalNotices(communityEid);
    }

    /**
     * Récupère les mentions légales d'une communauté
     * @param communityEid idenfiant d'une communauté
     */
    saveLegalNotices(communityEid) {
        return this.LegalNoticeDA.saveLegalNotices(communityEid);
    }

    disableProductCatalogManagementForAllSubEntities(communityId) {
        return this.CommunityDA.disableProductCatalogManagementForAllSubEntities(communityId);
    }
}

angular.module('app.community').service('CommunitySvc', CommunitySvc);
